import { MIN_PASSWORD_LENGTH } from '../signUp/constants';

interface IValidatorProps {
  getFieldValue: (value: string) => string;
}

export interface IValidator {
  validator: (_: unknown, value: string) => Promise<void>;
}

export const validatePassword = (): IValidator => ({
  validator: (_: unknown, value: string) => {
    if (value && `${value}`.length < MIN_PASSWORD_LENGTH) {
      return Promise.reject(`Invalid password. At least ${MIN_PASSWORD_LENGTH} characters are required`);
    }
    return Promise.resolve();
  }
});

export const validatePasswordConfirmation = ({ getFieldValue }: IValidatorProps): IValidator => ({
  validator: (_: unknown, value: string) => {
    if (!value || getFieldValue('password') === value) {
      return Promise.resolve();
    }
    return Promise.reject('The two passwords that you entered do not match!');
  }
});
